export default __webpack_public_path__ + "static/media/single-3.2891a74e.jpg";